export default __webpack_public_path__ + "static/media/reloadFaq3.d9d28ffa.png";